import apiService from '../services/apiService'
import PostAPI from '../components/views/Post/postApi'
import generalConfig from '@/config'
import postConfig from '../components/views/Post/postConfig'
import utils from '@/utils'
const postServiceBaseURL = generalConfig.apiServiceBaseURL.post // use of post service base url
const state = {
  strPostDeliverables: '',
  totalDeliverables: 0,
  updated: false
}

const actions = {
  /**
   * update post by ids
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async updatePostByIds ({commit}, data) {
    try {
      commit('UNSET_POST_UPDATED')
      await PostAPI.updatePostByIds(data)
      commit('SET_POST_UPDATED')
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update view post
   * @param {*} commit
   * @param {*} payload
   * @returns
  */
  async updatePostViewUser ({commit}, payload) {
    try {
      await PostAPI.updatePostViewUser(payload)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update post owner
   * @param {*} commit
   * @param {*} payload
   * @returns
  */
  async updatePostOwner ({commit}, payload) {
    try {
      commit('UNSET_POST_UPDATED')
      await PostAPI.updatePostOwner(payload)
      commit('SET_POST_UPDATED')
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  setPostDeliverables: ({ commit }, posts) => {
    let deliverableTypes = utils.func.refreshJSON(postConfig.postTypeDeliverables)
    deliverableTypes.push({
      type: 'Unknown',
      shortName: 'Unknown',
      value: 0
    })
    posts.map(post => {
      let index = deliverableTypes.findIndex(d => d.type === post.type)
      if (post.type === 'post/carousel') {
        index = deliverableTypes.findIndex(d => d.type === 'carousel')
      }
      if (index !== -1) {
        deliverableTypes[index].value += 1
      } else {
        // if no deliverable types, count to unknown
        deliverableTypes[deliverableTypes.length - 1].value += 1
      }
    })
    commit('SET_DELIVERABLE_STR', deliverableTypes)
    commit('SET_TOTAL_DELIVERABLES', deliverableTypes)
  },
  /**
   * send propose date client email
   * @param {*} commit
   * @param {*} payload
   * @returns
  */
  async sendProposeDateClientEmail ({commit}, payload) {
    try {
      await PostAPI.sendProposeDateClientEmail(payload)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * send revise date email
   * @param {*} commit
   * @param {*} payload
   * @returns
  */
  async sendReviseDateEmail ({commit}, payload) {
    try {
      await PostAPI.sendReviseDateEmail(payload)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * send propose date accepted client email
   * @param {*} commit
   * @param {*} payload
   * @returns
  */
  async sendProposeDateAcceptedToClient ({commit}, payload) {
    try {
      await PostAPI.sendProposeDateAcceptedToClient(payload)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * send confirm date email to cs team
   * @param {*} commit
   * @param {*} payload
   * @returns
  */
  async sendConfirmLiveDateEmailCO ({commit}, payload) {
    try {
      await PostAPI.sendConfirmLiveDateEmailCO(payload)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * send client accepted post
   * @param {*} commit
   * @param {*} payload
   * @returns
  */
  async sendClientAcceptPost ({commit}, payload) {
    try {
      await PostAPI.sendClientAcceptPost(payload)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async saveLiveDate({commit}, payload) {
    try {
      commit('SET_DATA', {
        name: 'updated',
        data: false
      })
      await apiService.post(postServiceBaseURL + '/update/live-date', payload)
      commit('SET_DATA', {
        name: 'updated',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update post types
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async updatePostTypes ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'updated',
        data: false
      })
      await apiService.post(postServiceBaseURL + '/update/post-type', data)
      commit('SET_DATA', {
        name: 'updated',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  }
}

const getters = {
}

/**
 * Need actions to implement
 */
// const actions = {}

const mutations = {
  SET_DELIVERABLE_STR(state, data) {
    let results = []
    data.map(d => {
      if (d.value > 0) {
        results.push(`${d.value} X ${d.shortName}`)
      }
    })
    state.strPostDeliverables = results.join(', ')
  },
  SET_TOTAL_DELIVERABLES(state, data) {
    state.totalDeliverables = data.map(im => parseInt(im.value)).reduce((a, b) => a + b, 0)
  },
  SET_POST_UPDATED(state) {
    state.updated = true
  },
  UNSET_POST_UPDATED(state) {
    state.updated = false
  },
  SET_DATA(state, { name, data }) {
    state[name] = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/post.js